<template>
  <div class="forum-box">
    <div class="forum-ul">
      <div class="forum-li" v-for="(item, index) in list" :key="index" @click="onClickRoute(item)">
        <div class="forum-top">
          <img v-if="item.avatar && item.avatar.url != undefined" :src="item.avatar.url" />
          <img v-else src="@/assets/images/defaultHead.png" />
          <div class="forum-user">
            <div class="user-name">{{ item.userNickName }}</div>
            <div class="time">{{ item.createTimeFormat }}</div>
          </div>
        </div>
        <div class="forum-text">{{ item.noteContent }}</div>
        <div class="forum-img" :class="{ active: (item.noteImages && item.noteImages.length > 2) }">
          <!-- <img v-for="(img, idx) in item.noteImages" :key="idx" :src="img.url" alt="img" /> -->
          <div class="forum-img-item" v-for="(img, idx) in item.noteImages" :key="idx">
            <el-image :src="img.url" :preview-src-list="showImgList(item.noteImages)" fit="contain" @click="handlePreview"></el-image>
          </div>
        </div>
      </div>
    </div>
    <empty class="empty-margin" v-if="list.length <= 0"></empty>
    <el-pagination class="paging" background :current-page="page.number" :page-sizes="[10, 20, 30, 40]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total" @size-change="sizeChange"
      @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick" />
  </div>
</template>

<script>
import empty from "@/components/empty/index";
export default {
  name: 'Forum',
  components: { empty },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    page: {
      type: Object,
      default: () => {
        return {
          number: 1,
          limit: 10,
          total: 0,
        }
      }
    },
  },
  data() {
    return {
      toggleStatus: [] // 每条帖子有两个状态字段：{ first: false, third: false }
    }
  },
  watch: {
    list: {
      handler(newVal) {
        // this.toggleStatus = newVal.map(() => ({ first: false, third: false }))
      },
      immediate: true
    }
  },
  methods: {
    showImgList(value) {
      let temporary = JSON.parse(JSON.stringify(value))
      let temporaryTwo = []
      temporary.forEach(item => {
        temporaryTwo.push(item.url)
      })
      return temporaryTwo
    },
    handlePreview(event) {
      event.stopPropagation();
    },
    onClickRoute(value) {
      this.$router.push(`/ForumCenterDetails/${value.id}`)
    },
    sizeChange(value) {
      this.$emit('sizeChange', value)
    },
    currentChange(value) {
      this.$emit('currentChange', value)
    },
    prevClick(value) {
      this.$emit('currentChange', value)
    },
    nextClick(value) {
      this.$emit('currentChange', value)
    },
  }
}
</script>

<style scoped lang="less">
.forum-ul {
  .forum-li {
    cursor: pointer;
    border-bottom: 0.5px solid #E5E5E5;
    text-align: left;

    .forum-img.active {
      img {
        height: 88px;
      }
    }

    .forum-img {
      display: flex;
      align-items: center;
      margin-top: 14px;

      .forum-img-item {
        height: 220px;
        margin-right: 12px;
        
        /deep/.el-image {
          height: 220px;
        }
      }
    }

    .forum-text {
      color: #525252;
      font-size: 14px;
      line-height: 22px;
      margin-top: 18px;
    }

    .forum-top {
      display: flex;
      align-items: center;

      .forum-user {
        .user-name {
          color: #404040;
          font-size: 14px;
          line-height: 14px;
        }

        .time {
          color: #A3A3A3;
          font-size: 12px;
          margin-top: 4px;
        }
      }

      img {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        margin-right: 6px;
        overflow: hidden;
      }
    }

    background: #fff;
    border-radius: 6px;
    margin-bottom: 10px;
    padding: 14px 20px;
  }
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ForumCenter/components/forumTwo.vue